export default "__VITE_ASSET__8392ccec__"